import React, { Component } from 'react';

import { DefaultDraftBlockRenderMap } from 'draft-js';
import Editor from '@draft-js-plugins/editor';
import has from 'lodash/has';
//import createMentionPlugin from '@draft-js-plugins/mention';
import createMentionPlugin, { defaultSuggestionsFilter } from './draftPlugins/mentions';
// import MentionSuggestions from './draftPlugins/mentions/MentionSuggestions';
// import defaultSuggestionsFilter from './draftPlugins/mentions/utils/defaultSuggestionsFilter';

import './editorStyles.css';

import createSingleLinePlugin from 'draft-js-single-line-plugin';

import './draftPlugins/mentions/styles/mentionStyles.css';

import './draftPlugins/mentions/styles/mentionSuggestionsEntryStyles.css';
import './draftPlugins/mentions/styles/mentionSuggestionsStyles.css';
const mentionTheme = {
  mention: 'mention',
  mentionSuggestions: 'mentionSuggestions',
  mentionSuggestionsEntry: 'mentionSuggestionsEntry',
  mentionSuggestionsEntryFocused: 'mentionSuggestionsEntryFocused',
  mentionSuggestionsEntryText: 'mentionSuggestionsEntryText',
  mentionSuggestionsEntryAvatar: 'mentionSuggestionsEntryAvatar',
  mentionSuggestionsEntryTitle: 'mentionSuggestionsEntryTitle',
};
const commonStyles = {
  mentionComponent: {
    cursor: 'default',
    color: '#ff7436',
  },
};

const setMentionPlugin = (mentionProps) => {
  const mentionPlugin = createMentionPlugin({
    theme: mentionTheme,
    mentionTrigger: ['{'],
    supportWhitespace: true,
    // mentionPrefix: '{{',
    // mentionSuffix: '}}',
    entityMutability: 'IMMUTABLE',
    // mentionRegExp: '\\{\\{(.*?) \\}\\}*',
    mentionComponent: (props) => {
      return <span style={commonStyles.mentionComponent}>{props.children}</span>;
    },
    //mentionSuggestionsComponent: MentionSuggestions
  });

  return mentionPlugin;
};
const setSingleLinePlugin = (props) => {
  const { isSingleLine } = props;
  if (isSingleLine) {
    return createSingleLinePlugin({ stripEntities: false });
  } else {
    return null;
  }
};

const setPlugins = (mentionsPlugin, singleLinePlugin = null) => {
  if (singleLinePlugin) {
    return [mentionsPlugin, singleLinePlugin];
  } else {
    return [mentionsPlugin];
  }
};
class MentionsBasicEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSuggestionsPopupOpen: false,
    };
    this._mentionsPlugin = setMentionPlugin(props);
    this._singleLinePlugin = setSingleLinePlugin(props);
    this._plugins = setPlugins(this._mentionsPlugin, this._singleLinePlugin);
    this._onSearchChange = this._onSearchChange.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onAddMention = this._onAddMention.bind(this);
    this._onHandleReturn = this._onHandleReturn.bind(this);
    this._onSuggestionPortalOpened = this._onSuggestionPortalOpened.bind(this);
  }

  _onSearchChange({ trigger, value }) {
    const { allSuggestions } = this.props;
    let newSuggestions = defaultSuggestionsFilter(value, allSuggestions, trigger);
    this.props.onSearchChange(newSuggestions);
  }

  _onFocus() {
    this.editor.focus();
  }

  _onHandleReturn(event, editorState) {
    //TODO: should not trigger return if popup is open.
    //Temp hack because the initial opupstate is marked as open even though itis not open.
    if (this.props.onReturn) {
      this.props.onReturn(event, editorState);
    }
    // if (this.state.isSuggestionsPopupOpen === false) {
    //   if (this.props.onReturn) {
    //     this.props.onReturn(event, editorState);
    //   }
    // }
  }

  _onAddMention(mention) {
    const { onSelected } = this.props;
    if (onSelected) {
      onSelected(mention);
    }
  }

  _onSuggestionPortalOpened(open = false) {
    // const { isSuggestionsPopupOpen } = this.state;
    // if (isSuggestionsPopupOpen !== open) {
    this.setState({
      isSuggestionsPopupOpen: open,
    });
    // }
  }

  render() {
    const { isSingleLine, style, disableMentions } = this.props;
    const { MentionSuggestions } = this._mentionsPlugin;
    let className = has(this.props, 'className') ? this.props.className : 'editor-single';

    className = `djs ${isSingleLine ? 'editor-single-file-folder' : ''} ${className}`;

    return (
      <div className={className} onClick={this._onFocus} style={style}>
        <Editor
          editorKey={this.props.editorKey || 'default_editor_key'}
          editorState={this.props.editorState}
          onChange={this.props.onChange}
          plugins={this._plugins}
          handleReturn={this._onHandleReturn}
          blockRenderMap={
            isSingleLine ? this._singleLinePlugin.blockRenderMap : DefaultDraftBlockRenderMap
          }
          ref={(element) => {
            this.editor = element;
          }}
        />
        {!disableMentions && (
          <MentionSuggestions
            open={this.state.isSuggestionsPopupOpen}
            suggestions={this.props.suggestions}
            onAddMention={this._onAddMention}
            onOpenChange={(open) => {
              this._onSuggestionPortalOpened(open);
            }}
            onSearchChange={this._onSearchChange}
            groupByKey={this.props.groupByKey}
            groupDisplayNameKey={this.props.groupDisplayNameKey}
          />
        )}
      </div>
    );
  }
}

MentionsBasicEditor.defaultProps = {
  isSingleLine: false,
  style: {},
  groupByKey: null,
  groupDisplayNameKey: null,
  groupByEntryComponent: null,
};

export default MentionsBasicEditor;
